﻿import { OnDestroy , Component, Input, Output, EventEmitter, ElementRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DataTable } from "angular2-datatable";
import { DomSanitizer } from "@angular/platform-browser";
import { Alert } from "../shared/modal/alert"
import { DataService } from "../services/dataService";
import { Modal } from "../shared/dialog/dialog.component";
import { ModalService } from "../shared/dialog/dialog.service";
import { TextBoxComponent } from "../shared/Textbox/textBox.component";
import { ValidationMessage } from "../validation/validationMessage";
import { ValidationMessageType } from "../validation/validationMessageType";
import { SearchCasesFilterPipe } from "../pipes/searchCases-filter.pipe";
import { Observable,interval , of } from "rxjs";

declare var $: any;
//import { County } from "../models/county.model";

import * as moment from 'moment';
import { Date } from "core-js/library/web/timers";
@Component({
    host: { "(document: keyup)": "keyup($event)" },
    selector: "jax-removalrequestcomponent",
    templateUrl: "./removalrequest.component.html"
})

export class RemovalRequestComponent {
    public data;
    public currentUser: any;
    public searchRequestsClicked: boolean;
    public requests: any = {};
    public sortBy = "FirstName";
    public sortOrder = "asc";
    public rowsOnPage = 10;
    public searchCompleted = false;
    public hasError = false;
    public totalRecord = 0;
    public dtable: DataTable;
    public isCaseDetail = false;
    public errorMessage: string;
    public validationMessage: ValidationMessage;
    public pdfMessage: ValidationMessage;
    public isCompleted = false;
    public todaysDate: string;
    public interval: any;
    public todays_Dt: Date;
    public removableOrders: any = {};
    public counties: any = [];
    public searchFields: CaseSearchFields[] = new Array();
    public searchFieldId: string = "";
    private isRequestDelete: boolean = false;
    public obs: any;
    private MODAL_ID: string;
    public selectedRequest: any = {};
    public cancelProgress:boolean=false;
    private appRequestId : number;
    private orderRequestId : number;


    @ViewChild('closeModal') closeModal: ElementRef;
    @ViewChild(Alert) alert: Alert;
    


    constructor(private route: ActivatedRoute,
        private dataService: DataService,
        private router: Router,
        private modalService: ModalService,
        private sanitizer: DomSanitizer,
        private elementref: ElementRef)
    {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        this.selectedRequest.selectedRequestId = 0;
        this.selectedRequest.selectedRequestNumber = "";
        this.selectedRequest.cancelReason = "";
        this.selectedRequest.cancelReasonError = false;
        this.selectedRequest.Status = "";
        this.selectedRequest.cancelReason = "";
    }
    public ngOnInit() {
        this.isCompleted = true;
        this.GetCounties();
       // this.getRRRequests(); 
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (currentUser && currentUser.Token) {
        }
        this.todaysDate =  moment().format("YYYY-MM-DD");
        this.requests.endDate = this.todaysDate;
        this.requests.startDate = moment().subtract('days', 30).format("YYYY-MM-DD");
        this.requests.dcs_firstName = currentUser.FirstName; 
        this.requests.dcs_lastName = currentUser.LastName;


        this.searchRequests();

        this.obs = interval(1000000).subscribe(x => {
            if (this.requests.countyId != null) {
                if (this.requests.countyId == "") {
                    this.requests.countyId = 0;
                }
                this.requests.selectedcounty = this.counties.find(c => c.id === this.requests.countyId);
            } else {
                this.requests.selectedcounty = this.counties.find(c => c.id === 37180475);
                this.requests.countyId = 37180475;
            }
            this.dataService.post("rorequests/searchrequests", JSON.stringify(this.requests)).subscribe(
                (response) => {
                    this.data = response.RRRequestResults;
                    this.totalRecord = this.data.length;
                    this.searchCompleted = true;
                });
        });

        
    }

    public ngOnDestroy() {
        this.obs.unsubscribe();
    }

    public getRRRequests() {
        this.dataService.get("rorequests/removalrequests").subscribe(resp => {
            this.data = resp;
            this.totalRecord = this.data.length;
            console.log(this.data);
          
            this.searchCompleted = true;
          
            this.hasError = false;
        });

           
    }
    private GetCounties() {
        this.dataService.get("common/counties").subscribe(resp => {
            this.counties = resp;
            this.counties.unshift({ id: "0", value: "All Counties"});
            let cc = this.counties.find(c => c.id == 0);
            if (cc) {
                this.requests.selectedcounty = cc;
                this.requests.countyId = cc.id;
            } else {
                this.requests.selectedcounty = this.counties.find(c => c.id == 0);
                this.requests.countyId = 0;
            }
           
        });
    }

    public cancelRRRequest(cm:any) {
        this.validationMessage = new ValidationMessage();
        let message = new ValidationMessage();

        let userId = this.currentUser.UserId;
        let cancelReason = this.selectedRequest.cancelReason;

        if (this.selectedRequest.cancelReasonError || !this.selectedRequest.cancelReason) {
            this.selectedRequest.cancelReasonError = true;
            return false;
        }

        let cancelReqest :any =  {
            RequestId:this.selectedRequest.selectedRequestId,
            Userid : userId,
            CancelReason : cancelReason
        };
        this.cancelProgress = true;
        this.dataService.post("rorequests/cancelremovalrequest", JSON.stringify(cancelReqest)).subscribe(
            (response) => {
                if (response.Succeeded == 1) {
                    message.messageType = ValidationMessageType.Ok;
                    let rrRequest: any = this.data.find(p => p.RemovalRequestID === this.selectedRequest.selectedRequestId);
                    if (rrRequest !== undefined) {
                        let index = this.data.indexOf(rrRequest);
                        if (index !== -1) {
                            this.data[index].Status = "Cancelled";
                            this.data[index].StatusId = 37232914;
                            this.data[index].RequestCancelReason = cancelReason;
                        }
                    }
                    this.cancelProgress = false;
                    cm.click();
                }
                else {
                    message.messageType = ValidationMessageType.Error;
                }
                message.message = response.Message;
                this.validationMessage = message;
                this.cancelProgress = false;
            });
    }


    public deleteRRRequest(rrNumber:number) {
        this.validationMessage = new ValidationMessage();
        let message = new ValidationMessage();
        this.dataService.post("rorequests/deleteremovalrequest?requestId=" + rrNumber).subscribe(
            (response) => {
                if (response.Succeeded == 1) {
                    message.messageType = ValidationMessageType.Ok;
                    let rrRequest: any = this.data.find(p => p.RemovalRequestID === rrNumber);
                    if (rrRequest !== undefined) {
                        let index = this.data.indexOf(rrRequest);
                        if (index !== -1) {
                            this.data.splice(index, 1);
                        }
                    }
                }
                else {
                    message.messageType = ValidationMessageType.Error;
                }
                message.message = response.Message;
                this.validationMessage = message;
            });


    }
    public openNewRemovalRequest(requestNumber: string, requestStatus: string) {
        if (!requestNumber) {
            this.router.navigate(["../createremovalrequest"],
                { relativeTo: this.route });
        } else {
            this.router.navigate(["../createremovalrequest"],
                {
                    relativeTo: this.route,
                    queryParams: { requestNumber: requestNumber }
                });
        }

    }

    public printApplication(requestNumber:any,isPrintOrder:boolean) {
        this.dataService.sharedService.openPopupWindow();
        this.dataService.getPdf("rorequests/RRRequestPdf?removalRequestID=" + requestNumber + "&isPrintOrder=" + isPrintOrder)
            .subscribe((res) => {
               this.dataService.sharedService.displayPdf(res,"request.pdf");              
            },
            (error) => {
                this.errorMessage = error.message;
                this.isCompleted = true;
                this.hasError = true;
                this.dataService.sharedService.closePopupWindow();
            });
    }    
    public clearSearch() {
        this.requests.child_firstName = null;
        this.requests.child_lastName = null;
        this.requests.child_dob = null;

        this.requests.dcs_firstName = null;
        this.requests.dcs_lastName = null;
        
        this.requests.RemovalRequestNumber = null;

       this.requests.selectedcounty = null;

        this.requests.startDate = null;
        this.requests.endDate = null;
        this.data = "";
        this.totalRecord = this.data.length;
        this.searchRequestsClicked = false;
        this.validationMessage = null;
       
    }
    public autocompleListFormatter = (data: any) => {
        let html = `<span>${data.value}</span>`;
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    public searchRequests() {
       
        this.searchRequestsClicked = true;
        this.searchCompleted = false;
        this.data = "";
        this.totalRecord = 0;
        this.validationMessage = null;

 
        let message = new ValidationMessage();
        if (this.requests.countyId != null) {
            if (this.requests.countyId == "") {
                this.requests.countyId = 0;
            }
            this.requests.selectedcounty = this.counties.find(c => c.id === this.requests.countyId);
        } else {
            this.requests.selectedcounty = this.counties.find(c => c.id === 37180475);
            this.requests.countyId = 37180475;
        }

        if (!this.validateSearchCriteria()) {
            this.dataService.post("rorequests/searchrequests", JSON.stringify(this.requests)).subscribe(
                (response) => {
                    this.data = response.RRRequestResults;
                    this.totalRecord = this.data.length;
                    this.searchCompleted = true;
                    this.errorMessage = "";
                    if (this.requests.countyId==0) {
                        this.requests.countyId = "";
                    }
                },
                (error) => {
                    this.errorMessage = error.message;
                    this.searchCompleted = true;
                    this.hasError = true;
                    if (this.requests.countyId==0) {
                        this.requests.countyId = "";
                    }
                });
        } else {
            this.searchRequestsClicked = false;
            this.searchCompleted = true;
            if (this.requests.countyId==0) {
                this.requests.countyId = "";
            }
        }
    }
    private isValid(val: any) {
        return (val !== "undefined" && val);
    }
    private validateSearchCriteria() {
     
        this.validationMessage = null;
        let rrNumberRegEx = /^RR\d{4}-\d{5}$/;
        let msg = new ValidationMessage();
        msg.messageType = ValidationMessageType.Error;
        let isError = false;
        if ((this.isValid(this.requests.child_firstName) && !this.isValid(this.requests.child_lastName)) ||
            (this.isValid(this.requests.child_lastName) && !this.isValid(this.requests.child_firstName)) ||
            (this.isValid(this.requests.dcs_firstName) && !this.isValid(this.requests.dcs_lastName)) ||
            (this.isValid(this.requests.dcs_lastName) && !this.isValid(this.requests.dcs_firstName)) ||
            (this.isValid(this.requests.RemovalRequestNumber) && !rrNumberRegEx.test(this.requests.RemovalRequestNumber))
        )
        {
            isError = true;
        }

        if (isError) {
            if ((this.isValid(this.requests.RemovalRequestNumber) && !rrNumberRegEx.test(this.requests.RemovalRequestNumber))) {
                msg.message = `Removal Request# must be formatted as RRyyyy-nnnnn`;
            } else {
                msg.message =
                `<ul>Atleast one of the following are required
                <li>Both First Name and Last Name</li>
                <li>Date of Birth</li><li>Start Date</li><li>End Date</li>
                <li>Removal Request number</li>
                <li>County</li>
                </ul>`;
            }
            this.validationMessage = msg;
        } else {
            $.fn.collapse("#search", "#searchresult");
        }
        return isError;
    }

    public canAccessRequest(requestDCSUserId : number) {
        //let isRequestDeleteEnable = this.currentUser.RemovalRequestDeleteEnable;
        if (requestDCSUserId === this.currentUser.UserId || this.currentUser.RemovalRequestDeleteEnable) {
            return true;
        } else
            return false;
    }

    public setselectedRequest(requestId: number, requestNumber: string,status:string, cancelReason:string) {
        this.selectedRequest.selectedRequestId = requestId;
        this.selectedRequest.selectedRequestNumber = requestNumber;
        this.selectedRequest.cancelReason = "";
        this.selectedRequest.cancelReasonError = false;
        this.selectedRequest.Status = status;
        this.selectedRequest.cancelReason = cancelReason;
    }


    public confirmOpenRecreatePDFApp(requestId : number) {
        this.appRequestId = requestId;
        this.alert.cancelButton = true;
        this.alert.okButton = true;
        this.alert.alertTitle = "Re-Create removal request application?";
        this.alert.message = "This will recreate the removal request application.<br>Do you want to continue? ";
        this.alert.okButtonText = "Yes";
        this.alert.okButtonType = "btn-danger";
        this.alert.cancelButtonText = "No";
        this.alert.open();
    }

    public confirmCloseRecreatePDFApp(event) {
        let e = event;
        if (this.appRequestId > 0) {
            this.recreatePDFApp(this.appRequestId);
        }
        this.appRequestId = 0;
    }


    public confirmOpenRecreatePDFOrder(requestId : number) {
        this.orderRequestId = requestId;
        this.alert.cancelButton = true;
        this.alert.okButton = true;
        this.alert.alertTitle = "Re-Generate removal request order?";
        this.alert.message = "This will regenerate the removal request order.<br>Do you want to continue? ";
        this.alert.okButtonText = "Yes";
        this.alert.okButtonType = "btn-danger";
        this.alert.cancelButtonText = "No";
        this.alert.open();
    }

    public confirmCloseRecreatePDFOrder(event) {
        let e = event;
        if (this.orderRequestId > 0) {
            this.recreatePDFOrder(this.orderRequestId);
        }
        this.appRequestId = 0;
    }

    
    public recreatePDFApp(requestNumber: any) {

        this.pdfMessage = new ValidationMessage();
        let message = new ValidationMessage();

        this.dataService.get("rorequests/regenerateapplication?removalRequestID=" +
                requestNumber +
                "&UserId=" +
                this.currentUser.UserId)
            .subscribe((res) => {
                    let resp = res;
                    if (resp.Succeeded == 1) {
                        message.messageType = ValidationMessageType.Ok;
                        this.hasError = false;
                    } else {
                        message.messageType = ValidationMessageType.Error;
                    }
                    this.isCompleted = true;
                    message.message = resp.Message;
                    this.pdfMessage = message;
                },
                (error) => {
                    message.messageType = ValidationMessageType.Error;
                    message.message = error;
                    this.isCompleted = true;
                    this.hasError = true;
                    this.pdfMessage = message;
                });
    } 

    public recreatePDFOrder(requestNumber: any) {
        this.pdfMessage = new ValidationMessage();
        let message = new ValidationMessage();

        this.dataService.get("rorequests/regenerateorder?removalRequestID=" +
                requestNumber +
                "&UserId=" +
                this.currentUser.UserId)
            .subscribe((res) => {
                    let resp = res;
                    if (resp.Succeeded == 1) {
                        message.messageType = ValidationMessageType.Ok;
                        this.hasError = false;
                    } else {
                        message.messageType = ValidationMessageType.Error;
                    }
                    this.isCompleted = true;
                    message.message = resp.Message;
                    this.pdfMessage = message;
                },
                (error) => {
                    message.messageType = ValidationMessageType.Error;
                    message.message = error;
                    this.isCompleted = true;
                    this.hasError = true;
                    this.pdfMessage = message;
                });
    } 
    
private keyup(event: KeyboardEvent): void {
        if (event.keyCode === 13) {
            this.searchRequests();
        }
    }
  
}
export class CaseSearchFields {
    public Id: string;
    public Name: string;
    public Type: string;
    constructor() {
        this.Id = "";
        this.Name = "--Select--";
        this.Type = "string";
    }
}